module.exports = __webpack_public_path__ + "90301aa07d780a09812229d6375c3b28.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/lato/Lato-Light.woff
// module id = 591
// module chunks = 0